/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import Button from "../Layout/Button";
import Modal from "../Modal/Modal";
import Typography from "../Typography/Typography";

export default function Alert({ open, onClose, onSubmit }) {
  return (
    <Box>
      <Modal
        open={open}
        onClose={onClose}
        // fullWidth="50%"
        // PaperProps={{ sx: { minHeight: 100 } }}
        // aria-labelledby="alert-dialog-title"
        // aria-describedby="alert-dialog-description"
      >
        <Typography
          style={{
            // color: "#8C8C8C",
            fontSize: "20px ",
            fontWeight: "500",
            paddingBottom: "20px",
          }}
        >
          Are you sure?
        </Typography>
        <Box
          style={{
            display: "flex",
            // paddingTop: "50px",
            justifyContent: "space-between",
          }}
        >
          {/* <Button
            onClick={onSubmit}
            label="Yes"
            style={{
              marginRight: "10px",
            }}
          /> */}
          <Button
            onClick={onSubmit}
            style={{
              marginRight: "10px",
            }}
          >
            Yes
          </Button>
          <Button onClick={onClose} cancel>
            No
          </Button>
          {/* <Button onClick={onClose} label="No" variant="outlined" /> */}
        </Box>
      </Modal>
    </Box>
  );
}
